module.exports = __webpack_public_path__ + "img/IONIQ6.e21992b3.png";